import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401) {
    localStorage.removeItem('admin_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});

// Auth
export const adminLogin = (login, password) =>
  api.post('/admin/login', { login, password }).then(r => r.data);

// Ce que le compte ouvre, maintenant — et non ce qu'il ouvrait au login.
export const getMonRole = () =>
  api.get('/admin/mon-role').then(r => r.data);

// Techniciens
export const getTechniciens = () =>
  api.get('/admin/techniciens').then(r => r.data);

export const createTechnicien = (data) =>
  api.post('/admin/techniciens', data).then(r => r.data);

export const updateTechnicien = (id, data) =>
  api.put(`/admin/techniciens/${id}`, data).then(r => r.data);

export const deleteTechnicien = (id) =>
  api.delete(`/admin/techniciens/${id}`).then(r => r.data);

export const resetPassword = (id, password) =>
  api.post(`/admin/techniciens/${id}/reset-password`, { password }).then(r => r.data);

// Comptes-rendus
export const getCRList = (filters) =>
  api.get('/admin/cr', { params: filters }).then(r => r.data);

export const getCRDetail = (id) =>
  api.get(`/admin/cr/${id}`).then(r => r.data);

export const validateCR = (id, forfait_override) =>
  api.post(`/admin/cr/${id}/validate`, { forfait_override: forfait_override || null }).then(r => r.data);

// Les documents d'un compte rendu : lesquels partent, et le detail du devis.
export const getPiecesCR = (id) =>
  api.get('/admin/cr/' + id + '/pieces').then(r => r.data);
export const setPiecesCR = (id, exclues, envoiInterne) =>
  api.put('/admin/cr/' + id + '/pieces',
    { exclues, ...(envoiInterne === undefined ? {} : { envoi_interne: envoiInterne }) })
    .then(r => r.data);
export const getLignesDevis = (id) =>
  api.get('/admin/cr/' + id + '/devis/lignes').then(r => r.data);
export const setLignesDevis = (id, quantites) =>
  api.put('/admin/cr/' + id + '/devis/lignes', { quantites }).then(r => r.data);

export const getCREmailPreview = (id, forfait) =>
  api.get(`/admin/cr/${id}/email-preview`, { params: { forfait: forfait || undefined } }).then(r => r.data);

export const rejectCR = (id, motif) =>
  api.post(`/admin/cr/${id}/reject`, { motif }).then(r => r.data);

// Dashboard
export const getDashboard = () =>
  api.get('/admin/dashboard').then(r => r.data);

export const getDashboardAlertes = () =>
  api.get('/admin/dashboard/alertes').then(r => r.data);

export const deleteCR = (id) =>
  api.delete(`/admin/cr/${id}`).then(r => r.data);

export const getStats = (period, type, month) =>
  api.get('/admin/stats', { params: { period, type: type || 'all', month: month || undefined } }).then(r => r.data);

export const resendEmail = (id) =>
  api.post(`/admin/cr/${id}/resend-email`).then(r => r.data);

export const resetCRPending = (id) =>
  api.post(`/admin/cr/${id}/reset-pending`).then(r => r.data);

export const regeneratePDF = (id) =>
  api.post(`/admin/cr/${id}/regenerate-pdf`).then(r => r.data);

export const getActivity = () =>
  api.get('/admin/activity').then(r => r.data);

export const getAdminPlanning = (dateDebut, dateFin, stages = [], q = '') =>
  api.get('/admin/planning', { params: { dateDebut, dateFin, stages: stages.join(','), q } }).then(r => r.data);

// Les jours fériés de la période affichée, nommés. Le calcul reste au serveur
// pour qu'il n'y en ait qu'un : celui des délais.
export const getJoursFeries = (de, a) =>
  api.get('/admin/jours-feries', { params: { de, a } }).then(r => r.data);

export const demandeSuppressionWO = (id, dossier_ref = '') =>
  api.post(`/admin/planning/${id}/demande-suppression`, { dossier_ref }).then(r => r.data);

export const getImportStatsToday = () =>
  api.get('/admin/import/stats-today').then(r => r.data);

export const getImportHistory = (from, to) =>
  api.get('/admin/import/history', { params: { from, to } }).then(r => r.data);

export const getPlanningHistory = (from, to) =>
  api.get('/admin/import/planning-history', { params: { from, to } }).then(r => r.data);

export const triggerPlanningSnapshot = (type) =>
  api.post('/admin/import/planning-snapshot', { type }).then(r => r.data);

// Comptes conduite d'activité
export const getAccounts = () =>
  api.get('/admin/accounts').then(r => r.data);

export const createAccount = (data) =>
  api.post('/admin/accounts', data).then(r => r.data);

export const deleteAccount = (id) =>
  api.delete(`/admin/accounts/${id}`).then(r => r.data);

export const resetAccountPassword = (id, password) =>
  api.post(`/admin/accounts/${id}/reset-password`, { password }).then(r => r.data);

// Planification RDV
export const getPlanification = () =>
  api.get('/admin/planification').then(r => r.data);

export const updatePlanification = (id, data) =>
  api.put(`/admin/planification/${id}`, data).then(r => r.data);

export const getActionLogs = () =>
  api.get('/admin/action-logs').then(r => r.data);

export const getSettings = () =>
  api.get('/admin/settings').then(r => r.data);
export const saveSettings = (data) =>
  api.put('/admin/settings', data).then(r => r.data);

export const getSuiviCRIStats = () =>
  api.get('/admin/suivi-cri/stats').then(r => r.data);

export const getWAStatus    = () => api.get('/admin/whatsapp/status').then(r => r.data);
export const getWAMessages  = () => api.get('/admin/whatsapp/messages').then(r => r.data);
export const sendWATest     = (to, message) => api.post('/admin/whatsapp/send-test', { to, message }).then(r => r.data);
export const disconnectWA   = () => api.post('/admin/whatsapp/disconnect').then(r => r.data);
export const getWATemplates = () => api.get('/admin/whatsapp/templates').then(r => r.data);
export const updateWATemplate = (id, template) => api.put(`/admin/whatsapp/templates/${id}`, { template }).then(r => r.data);

// Emails
export const getEmails = () =>
  api.get('/admin/emails').then(r => r.data);

export const getEmailBody = (uid) =>
  api.get(`/admin/emails/${uid}/body`).then(r => r.data);

export const refreshEmails = () =>
  api.post('/admin/emails/refresh').then(r => r.data);

export const generateAiReply = (originalText, subject, from) =>
  api.post('/admin/emails/ai-reply', { originalText, subject, from }).then(r => r.data);

export const sendEmail = (to, subject, body, inReplyTo) =>
  api.post('/admin/emails/send', { to, subject, body, inReplyTo }).then(r => r.data);

export const logPageVisit = (page) =>
  api.post('/admin/activity/page-visit', { page }).catch(() => {});

export const getEmailLog = () =>
  api.get('/admin/email-log').then(r => r.data);

// Rôles
export const getRoles = () => api.get('/admin/roles').then(r => r.data);
export const createRole = (data) => api.post('/admin/roles', data).then(r => r.data);
export const updateRole = (id, data) => api.put(`/admin/roles/${id}`, data).then(r => r.data);
export const deleteRole = (id) => api.delete(`/admin/roles/${id}`).then(r => r.data);

// Mise à jour compte
export const updateAccount = (id, data) => api.put(`/admin/accounts/${id}`, data).then(r => r.data);

// Secteurs techniciens / couverture E-RDV
export const getCouvertureErdv = () => api.get('/admin/erdv/couverture').then(r => r.data);
export const saveCouvertureErdv = (data) => api.put('/admin/erdv/couverture', data).then(r => r.data);
export const verifierCouvertureErdv = (data) => api.post('/admin/erdv/couverture/verifier', data).then(r => r.data);
export const apercuErdv = (params) => api.get('/admin/erdv/apercu', { params }).then(r => r.data);

// Absences techniciens
export const getAbsences = (params) => api.get('/admin/absences', { params }).then(r => r.data);
export const getConflitsAbsence = (params) => api.get('/admin/absences/conflits', { params }).then(r => r.data);
export const createAbsence = (data) => api.post('/admin/absences', data).then(r => r.data);
export const deleteAbsence = (id) => api.delete(`/admin/absences/${id}`).then(r => r.data);

// Ou sont-ils : la journee relevee au telephone des techniciens.
export const getTerrain = (date) => api.get('/admin/terrain', { params: { date } }).then(r => r.data);
export const getTraceTerrain = (zoho_nom, date) =>
  api.get(`/admin/terrain/trace/${encodeURIComponent(zoho_nom)}`, { params: { date } }).then(r => r.data);
export const geocoderTerrain = (date) =>
  api.post('/admin/terrain/geocoder', null, { params: { date } }).then(r => r.data);

// Malus
export const getMalus = (mois, technicien) =>
  api.get('/admin/malus', { params: { mois, technicien } }).then(r => r.data);
export const deciderMalus = (id, action, motif) =>
  api.post(`/admin/malus/${encodeURIComponent(id)}/decision`, { action, motif }).then(r => r.data);
export const annoncerMalus = (id) =>
  api.post(`/admin/malus/${encodeURIComponent(id)}/notifier`).then(r => r.data);
export const exporterMalus = (params) =>
  api.get('/admin/malus/export.xlsx', { responseType: 'blob', params });

// Les devis qui attendent leur prix
export const getDevisSansMontant = () =>
  api.get('/admin/devis-sans-montant').then(r => r.data);

// Portail Covage
export const getPortailCovage = () =>
  api.get('/admin/portail-covage').then(r => r.data);
export const setPortailCovage = (patch) =>
  api.put('/admin/portail-covage', patch).then(r => r.data);

// Grille E-RDV
export const getGrilleErdv = (jours) => api.get('/admin/erdv/grille', { params: { jours } }).then(r => r.data);
export const forcerCreneauErdv = (data) => api.post('/admin/erdv/forcage', data).then(r => r.data);
export const getJournalErdv = (params) => api.get('/admin/erdv/journal', { params }).then(r => r.data);
export const recalculerErdv = (data) => api.post('/admin/erdv/recalculer', data).then(r => r.data);

export const getRecommandation = (params) => api.get('/admin/erdv/recommandation', { params }).then(r => r.data);

// Qualifications KPI declarees par la conduite d'activite
export const getQualification = (params) => api.get('/admin/erdv/qualification', { params }).then(r => r.data);
export const saveQualification = (data) => api.put('/admin/erdv/qualification', data).then(r => r.data);
// La liste des interventions qu'on peut sortir du calcul, tous motifs
// confondus. Le calcul traverse les historiques : le serveur la garde cinq
// minutes, `refresh` force.
export const getQualificationsAConfirmer = (params) =>
  api.get('/admin/kpi/qualifications', { params }).then(r => r.data);

// Fiche dossier (miroir Zoho)
export const rechercheFiche = (q) => api.get('/admin/fiche/recherche', { params: { q } }).then(r => r.data);
export const getFiche = (id) => api.get('/admin/fiche/' + id).then(r => r.data);
export const getWorkflowsCatalogue = () => api.get('/admin/workflows').then(r => r.data);
export const getWorkflowApercu = (id, params) =>
  api.get(`/admin/workflows/${id}/apercu`, { params }).then(r => r.data);
export const getWorkflowJournal = (id) =>
  api.get(`/admin/workflows/${id}/journal`).then(r => r.data);
export const simulerEscalades = () =>
  api.post('/admin/workflows/escalades/simulation', {}).then(r => r.data);
export const rattrapage48h = (date) =>
  api.post('/admin/workflows/prevenance_48h/rattrapage', { date }).then(r => r.data);
export const setWorkflowDestinataires = (id, destinataires) =>
  api.put(`/admin/workflows/${id}/destinataires`, { destinataires }).then(r => r.data);
export const setModeEssai = (actif, adresse) =>
  api.put('/admin/workflows/mode-essai', { actif, adresse }).then(r => r.data);
export const apercuActionFiche = (id, body) =>
  api.post(`/admin/fiche/${id}/apercu-action`, body).then(r => r.data);
export const envoyerReportRdv = (id, body) =>
  api.post(`/admin/fiche/${id}/report-rdv`, body).then(r => r.data);
export const abandonnerWo = (id, body) =>
  api.post(`/admin/fiche/${id}/abandon`, body).then(r => r.data);
export const ecrireChampsFiche = (id, champs, confirme) =>
  api.patch(`/admin/fiche/${id}/champs`, { champs, confirme: !!confirme }).then(r => r.data);
export const getMetaChampsFiche = () =>
  api.get('/admin/fiche/meta/champs').then(r => r.data);
export const saveArcArs = (id, body) =>
  api.put(`/admin/fiche/${id}/arc-ars`, body).then(r => r.data);
// `espace` choisit le casier : « technicien » par defaut — ce que l appli des
// techniciens affiche — ou « devis », que le panel seul voit.
const casier = (espace) => (espace ? `?espace=${encodeURIComponent(espace)}` : '');
export const getPiecesDossier = (id, espace) =>
  api.get(`/admin/pj/dossier/${id}${casier(espace)}`).then(r => r.data);
export const deposerPiece = (id, fichiers, espace) => {
  const f = new FormData();
  Array.from(fichiers).forEach(x => f.append('files', x));
  return api.post(`/admin/pj/upload/${id}${casier(espace)}`, f).then(r => r.data);
};
export const definirDureeFiche = (id, heures, confirme) =>
  api.put(`/admin/fiche/${id}/duree`, { heures, confirme }).then(r => r.data);
export const supprimerPiece = (id, nom, espace) =>
  api.delete(`/admin/pj/delete/${id}/${encodeURIComponent(nom)}${casier(espace)}`).then(r => r.data);
// Un devis monte a la main depuis la fiche : l'en-tete vient du dossier, les
// quantites se saisissent a l'ecran, et le fichier rejoint les pieces deposees.
export const creerDevisDossier = (id, corps) =>
  api.post(`/admin/dossier/${id}/devis`, corps || {}).then(r => r.data);
export const getLignesDevisDossier = (id, fichier) =>
  api.get(`/admin/dossier/${id}/devis/lignes`, { params: { fichier } }).then(r => r.data);
export const setLignesDevisDossier = (id, fichier, quantites) =>
  api.put(`/admin/dossier/${id}/devis/lignes`, { fichier, quantites }).then(r => r.data);
export const getErdvFiche = (id) =>
  api.get('/admin/fiche/' + id + '/erdv').then(r => r.data);
export const validerErdvFiche = (id, body) =>
  api.post('/admin/fiche/' + id + '/valider-erdv', body || {}).then(r => r.data);
// Poser directement un créneau que le moteur vient de proposer : la date,
// l'heure, le technicien, puis l'étape « Planifiée ».
export const poserRdvFiche = (id, body) =>
  api.post('/admin/fiche/' + id + '/poser-rdv', body || {}).then(r => r.data);
export const cocherFiche = (id, champ, valeur, confirme) =>
  api.patch('/admin/fiche/' + id + '/case',
    { champ, valeur, confirme: !!confirme }).then(r => r.data);

export default api;

// Les alertes du bandeau : ce qui a echoue sans que personne ne regarde.
export const getAlertes = (toutes) =>
  api.get('/admin/alertes' + (toutes ? '?toutes=1' : '')).then(r => r.data);
export const marquerAlerteVue = (id) =>
  api.post(`/admin/alertes/${id}/vu`).then(r => r.data);
export const marquerAlertesVues = () =>
  api.post('/admin/alertes/tout-vu').then(r => r.data);
